import { render } from "./checkbox.vue?vue&type=template&id=5a18e074"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=5a18e074&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script